import { render, staticRenderFns } from "./opt-in-form-wrapper.vue?vue&type=template&id=1a8300f6&scoped=true&"
import script from "./opt-in-form-wrapper.vue?vue&type=script&lang=js&"
export * from "./opt-in-form-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8300f6",
  null
  
)

export default component.exports